module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-42.233d0de4.png";